export const set_is_mobile_sidebar = (payload: any) => ({
  type: "MOBILE_SIDEBAR",
  payload
});
